import React from 'react';
import { useLocation } from '@reach/router';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';

import { removeLanguageFromPath } from '../utilities/url';

import { LANGUAGES, DEFAULT_LANGUAGE } from '../constants';

import Seo from './Seo';

const PageHead = ({ seo, title, language, updatedAt, canonicalPath }) => {
  const { site } = useStaticQuery(graphql`
    query Layout {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  const hasSeoTitle = seo?.title !== undefined && seo?.title !== null;
  let pageTitle = title;

  if (hasSeoTitle) {
    pageTitle = seo.title;
  } else if (!title?.includes(`| ${site.siteMetadata.title}`)) {
    pageTitle = `${title} | ${site.siteMetadata.title}`;
  }

  const { pathname } = useLocation();
  const pathWithoutLanguage = removeLanguageFromPath(pathname);
  const isBlogPost = pathWithoutLanguage.startsWith('/blog/');

  return (
    <>
      <html
        lang={
          LANGUAGES[language]
            ? LANGUAGES[language].hreflang
            : LANGUAGES[DEFAULT_LANGUAGE].hreflang
        }
      />
      <meta name="theme-color" content="#0d6dc0" />
      {language === 'zh-Hans' ? (
        <meta name="baidu-site-verification" content="code-EWGuDWj7yD" />
      ) : (
        <meta name="baidu-site-verification" content="code-BN0gTxCGYC" />
      )}
      {isBlogPost && <meta name="6sense_activity" content="blog" />}
      <script>
        {isBlogPost ? `
                var _hsq = window._hsq = window._hsq || []; _hsq.push(['setContentType', 'blog-post']);
              ` : `
                var _hsq = window._hsq = window._hsq || []; _hsq.push(['setContentType', 'standard-page']);
              `}
      </script>
      <Seo
        language={language}
        title={pageTitle}
        description={seo?.description}
        keywords={seo?.keywords || undefined}
        image={seo?.image}
        jsonLd={seo?.jsonLd}
        noIndex={seo?.noIndex}
        noFollow={seo?.noFollow}
        canonicalPath={canonicalPath}
        updatedAt={updatedAt}
      />
    </>
  );
};

PageHead.propTypes = {
  title: PropTypes.string,
  seo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    image: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    jsonLd: PropTypes.object,
    noIndex: PropTypes.bool,
    noFollow: PropTypes.bool
  }),
};

export default PageHead;
